import React, {
  useEffect,
  useState,
  CSSProperties,
  useRef,
} from 'react';

import { Link } from 'react-router-dom';

import { SiAboutdotme } from 'react-icons/si';
import { CgMenuMotion } from 'react-icons/cg';
import { AiFillGithub, AiOutlineMail } from 'react-icons/ai';
import { BiLogoLinkedin, BiExit } from 'react-icons/bi';
import { FaProjectDiagram } from 'react-icons/fa';
import { LuSquareStack } from 'react-icons/lu';

import '../../styles/UI/Navbar.scss';

function Navbar(): React.ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const minWith = 768;

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowWidth(window.innerWidth);
    });

    return () => {
      window.removeEventListener('resize', () => {
        setWindowWidth(window.innerWidth);
      });
    };
  }, [windowWidth]);

  const $menu = useRef<HTMLElement>(null);
  const iconSize = 30;

  const toggleMenu = () => {
    setIsOpen((isOpen) => !isOpen);

    $menu.current?.classList.toggle('active');
  };

  return (
    <nav
      ref={$menu}
      className="menu-navbar"
      aria-label="Menu"
      role="navigation"
    >
      {/* ! SHOW ONLY ON MOBILE */}
      <button
        className="toggle-menu my-btn hover-text"
        type="button"
        onClick={toggleMenu}
        title="Links"
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-label={isOpen ? 'Close Menu' : 'Open Menu'}
      >
        <CgMenuMotion size={iconSize} />
      </button>
      <ul>
        <li style={{ '--elem': 1 } as CSSProperties}>
          <a
            href="https://github.com/ITurres"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Author's Github Profile"
          >
            <AiFillGithub
              size={iconSize}
              title="Arthur's Github"
            />
          </a>
        </li>
        <li style={{ '--elem': 2 } as CSSProperties}>
          <a
            href="https://www.linkedin.com/in/arthuriturres/"
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Author's Linkedin Profile"
          >
            <BiLogoLinkedin
              size={iconSize}
              title="Arthur's Linkedin"
            />
          </a>
        </li>
        <li style={{ '--elem': 3 } as CSSProperties}>
          <Link to="/" aria-label="Exit to the Access page">
            <BiExit
              size={iconSize}
              title="Exit to Access Page"
            />
          </Link>
        </li>

        {/* ! SHOW ONLY ON MOBILE */}
        {windowWidth < minWith && (
          <>
            <li style={{ '--elem': 4 } as CSSProperties}>
              <Link
                to="/homepage"
                aria-label="About Me Page - learn more about Arthur"
              >
                <SiAboutdotme
                  size={iconSize}
                  title="About Arthur"
                />
              </Link>
            </li>
            <li style={{ '--elem': 5 } as CSSProperties}>
              <Link
                to="/homepage/projects"
                aria-label="Arthur's Projects Page - learn more about Arthur's projects"
              >
                <FaProjectDiagram
                  size={iconSize}
                  title="Arthur's Projects"
                />
              </Link>
            </li>
            <li style={{ '--elem': 6 } as CSSProperties}>
              <Link
                to="/homepage/contact"
                aria-label="Contact me Page - contact Arthur"
              >
                <AiOutlineMail
                  size={iconSize}
                  title="Contact Arthur!"
                />
              </Link>
            </li>
            <li style={{ '--elem': 7 } as CSSProperties}>
              <Link
                to="/homepage/expertise"
                aria-label="Expertise Page - learn more about the author's expertise"
              >
                <LuSquareStack
                  size={iconSize}
                  title="Arthur's Expertise"
                />
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
